import React, { useState } from 'react';
import { StringUtil } from 'utils/StringUtil';
import ImageInfoModule from 'components/templates/imageInfoModule';
import { OverlayModal } from 'components/templates/overlayModal';
import { OverlayPortal } from 'components/templates/overlayPortal';

const EDesign = props => {
  const {
    data: { eDesign },
    data,
  } = props.data;
  const { breadcrumbList } = props;
  const { customiseWithEDesign } = data;
  const [showDescriptionLayout, setshowDescriptionLayout] = useState(false);

  const eDesignHeading = StringUtil.sliceHtml(eDesign.heading);
  const paragraph1 = StringUtil.sliceHtml(eDesign.paragraph);
  const paragraph2 = StringUtil.sliceHtml(eDesign.sub_heading);
  const tagWord = StringUtil.sliceHtml(eDesign.tag_word);
  const eDesignImage = eDesign.image;
  const thumbnail = eDesign.image_thumbnail;

  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={customiseWithEDesign}
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'eDesign'}
        className={'ourHomesOverlay'}
        onClosePress={() => setshowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
          {
            breadcrumbName: breadcrumbList[2].breadcrumbName,
            breadcrumbLink: breadcrumbList[2].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div>
      <ImageInfoModule
        heading={eDesignHeading}
        first_content={paragraph1}
        second_content={paragraph2}
        onClick={e => setshowDescriptionLayout(true)}
        sectionImage={eDesignImage}
        buttonName={customiseWithEDesign ? 'EXPLORE EDESIGN' : false}
        containerClassName={''}
        tagWord={tagWord}
        thumbNailUrl={thumbnail}
        onGetInTouchClick={data.onGetInTouchClick}
      />
      {showOverlay}
    </div>
  );
};

export default EDesign;
